import {
  GET_SURVEY_RESULTS_SUCCESS,
  GET_SURVEY_RESULTS_FAILURE,
  GET_SURVEY_RESULTS_REQUESTED,
} from './surveyResults.constants'
import API from './surveyResults.api'

export const getSurveyResults = contactId => {
  return async dispatch => {
    dispatch(getSurveyResultsRequested())
    try {
      const events = await API.getSurveyResults(contactId)

      dispatch(getSurveyResultsSuccess(events))
    } catch (error) {
      dispatch(getSurveyResultsFailure(error))
    }
  }
}

export const getSurveyResultsRequested = () => ({
  type: GET_SURVEY_RESULTS_REQUESTED,
})

export const getSurveyResultsSuccess = data => ({
  data,
  type: GET_SURVEY_RESULTS_SUCCESS,
})

export const getSurveyResultsFailure = error => ({
  error,
  type: GET_SURVEY_RESULTS_FAILURE,
})
